import UIComponent from "sap/ui/core/UIComponent";

class GlobalRouter {
    private static instance: any;

    private constructor() { }

    public static initialize(component: UIComponent): void {
        if (!GlobalRouter.instance) {
            GlobalRouter.instance = component.getRouter();
        }
    }

    public static getInstance(): any {
        if (!GlobalRouter.instance) {
            console.error("Router instance is not initialized. Make sure to call Router.initialize(component) in your Component.ts.");
        }
        return GlobalRouter.instance;
    }
}

export default GlobalRouter;